import Uri from 'jsuri';

const isExternalLink = (url: string) => {
  const uri = new Uri(url);
  return !uri.host().includes('coursera.org');
};

export default isExternalLink;
